import ApprovalDetails from './ApprovalDetails';

export default ApprovalDetails;
